import React, { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const HoverMenu = ({ label, children }) => {
    const [open, setOpen] = useState(false);
    const timerRef = useRef(null);

    const onEnter = () => {
        if (timerRef.current) clearTimeout(timerRef.current);
        setOpen(true);
    };

    const onLeave = () => {
        timerRef.current = setTimeout(() => setOpen(false), 150);
    };

    return (
        <div className="relative" onMouseEnter={onEnter} onMouseLeave={onLeave}>
            <button type="button" className="inline-flex items-center gap-1 text-white/90 hover:text-white transition">
                <span>{label}</span>
                <svg className="w-3.5 h-3.5" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.108l3.71-3.878a.75.75 0 011.08 1.04l-4.24 4.43a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z" clipRule="evenodd" /></svg>
            </button>
            {open && (
                <div className="absolute mt-3 left-0 min-w-[240px] bg-white shadow-lg rounded-lg py-2 px-4 z-50 border border-gray-100">
                    {children}
                </div>
            )}
        </div>
    );
};

const Navbar = () => {
    const navigate = useNavigate();
    return (
        <header className="sticky top-0 z-40 bg-[#3C0F6C]/85 backdrop-blur supports-[backdrop-filter]:bg-[#3C0F6C]/70 border-b border-white/10">
            <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-16">
                <div className="h-16 flex items-center justify-between">
                    <Link to="/" className="flex items-center gap-2 text-white font-bold tracking-wide">
                        <img
                            src={require("../../img/rakfort.jpg")}
                            alt="Logo"
                            className="w-8 h-8 object-cover rounded"
                        />
                        <span>JobStep</span>
                    </Link>



                    <nav className="hidden md:flex items-center gap-8">
                        <Link className="text-white/90 hover:text-white" to="/">Home</Link>
                        <HoverMenu label="Features">
                            <div className="flex flex-col gap-2">
                                {/* <Link className="hover:text-[#3C0F6C] text-sm" to="/features">All Features</Link> */}
                                <Link className="hover:text-[#3C0F6C] text-sm" to="/resume-scoring">Resume Scoring</Link>
                                <Link className="hover:text-[#3C0F6C] text-sm" to="/interview-prep">AI Interview Prep</Link>
                                <Link className="hover:text-[#3C0F6C] text-sm" to="/interview-simulation">Interview Simulation</Link>
                            </div>
                        </HoverMenu>

                        <HoverMenu label="AI Tools">
                            <div className="flex flex-col gap-2">
                                {/* <Link className="hover:text-[#3C0F6C] text-sm" to="/ai-tools">All AI Tools</Link> */}
                                <Link className="hover:text-[#3C0F6C] text-sm" to="/cover-letter-generator">Cover Letter</Link>
                                <Link className="hover:text-[#3C0F6C] text-sm" to="/job-matching">Matching</Link>
                                <Link className="hover:text-[#3C0F6C] text-sm" to="/resume-builder">Resume Builder</Link>
                            </div>
                        </HoverMenu>

                        <Link className="text-white/90 hover:text-white" to="/signuppricing">Pricing</Link>
                        <Link className="text-white/90 hover:text-white" to="/blogs">Blogs</Link>
                        <Link className="text-white/90 hover:text-white" to="/contactus">Contact Us</Link>
                    </nav>

                    <div className="flex items-center gap-3">
                        <button onClick={() => navigate('/auth')} className="hidden md:inline-flex items-center gap-2 bg-[#FFD600] text-[#0E0E0E] font-semibold px-4 py-2 rounded-lg hover:brightness-95">
                            Sign Up
                        </button>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Navbar;


